import { render, staticRenderFns } from "./RtcGroupAcceptor.vue?vue&type=template&id=1aac3470&scoped=true"
import script from "./RtcGroupAcceptor.vue?vue&type=script&lang=js"
export * from "./RtcGroupAcceptor.vue?vue&type=script&lang=js"
import style0 from "./RtcGroupAcceptor.vue?vue&type=style&index=0&id=1aac3470&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/lyb/工作/个人/leo——im/新版代码/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aac3470",
  null
  
)

export default component.exports